import React from 'react'
// import Sidebar from '../Components/Sidebar'
import DetailPayout from '../Components/DetailPayout'
import HeaderTwo from './HeaderTwo'
import SidebarLayout from '../Components/sidebar/SidebarLayout'

const PayoutDetails = () => {
  return (
    <>
      <SidebarLayout>

        <HeaderTwo />
        <div id="wrapper" className="col-md-12">
          <div style={{ position: "relative" }}>
            {/* <Sidebar /> */}
            <DetailPayout />
          </div>
        </div>
      </SidebarLayout>
    </>

  )
}

export default PayoutDetails